import { render, staticRenderFns } from "./registrationConsultationEdit.vue?vue&type=template&id=0ecc4d5a&scoped=true"
import script from "./registrationConsultationEdit.vue?vue&type=script&lang=js"
export * from "./registrationConsultationEdit.vue?vue&type=script&lang=js"
import style0 from "./registrationConsultationEdit.vue?vue&type=style&index=0&id=0ecc4d5a&prod&lang=less&scoped=true"
import style1 from "./registrationConsultationEdit.vue?vue&type=style&index=1&id=0ecc4d5a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecc4d5a",
  null
  
)

export default component.exports